//This model represent the commons fields for an equipment. The type is also store in the equipment.
//There are 6 types of equipments.
//For eacm, ear and custom equipment we use the default Equipment interface.
//For extractors we use the extractors interface
//For workers airlock or wastes airlock we use the AirLock interface
export interface Equipment {
  id: string;
  completeName: string;
  model: string;
  constructor: string;
  description: string;
  order: number;
  image: Image;
  type: EquipmentType;
  dimensions?: Dimensions;
  abacus?: Point[]; //Always a list of flows from 0 to 50 Pa with a step of 5Pa;
  valueDebit?: number;
  //listSites?: sitesEacm[]; //Evolution Majeure pour EACM

}

export interface Image {
  path: string;
  alt: string;
}

//Evolution Majeure pour EACM
export interface sitesEacm {
  name: string;
}

export interface EquipmentDto {
  identifiant: string;
  titre: string;
  modele: string;
  description: string;
  numeroOrdre: number;
  marque: string;
  imageLink: string;
  imageAlt: string;
  typeMateriel: EquipmentTypeDto;
  hauteur: number;
  largeur: number;
  profondeur: number;
  poids: number;
  abaque?: AbaqueDto;
}

export interface AbaqueDto {
  groupe1: GroupeDto;
  groupe2: GroupeDto;
  groupe3: GroupeDto;
  groupe4: GroupeDto;
  groupe5: GroupeDto;
  groupe6: GroupeDto;
  groupe7: GroupeDto;
  groupe8: GroupeDto;
  groupe9: GroupeDto;
  groupe10: GroupeDto;
}

export interface GroupeDto {
  pointX: number;
  pointY: number;
}

//EquipmentType used in the front application
export enum EquipmentType {
  workersAirLock = "WORKERS_AIR_LOCK",
  wastesAirLock = "WASTES_AIR_LOCK",
  extractor = "EXTRACTOR",
  eacm = "EACM",
  ear = "EAR",
  custom = "CUSTOM",
}

//EquipmentType used in materiel objects coming from magnolia.
//We have to use this type when requesting the API
export enum EquipmentTypeDto {
  sasPersonel = "ABACA_TypeMateriel_1",
  sasDechets = "ABACA_TypeMateriel_2",
  extracteur = "ABACA_TypeMateriel_3",
  eacm = "ABACA_TypeMateriel_4",
  ear = "ABACA_TypeMateriel_5",
  none = "",
}

//EquipmentType used in categories coming from magnolia
export enum CategoryEquipmentTypeDto {
  sasPersonel = "Sas_Perso",
  sasDechets = "Sas_Dechets",
  extracteur = "Extracteur",
  eacm = "EACM",
  ear = "EAR",
}
export interface Dimensions {
  height: number; //mm
  width: number; //mm
  depth: number; //mm
  weight: number; //kg
}

export interface Point {
  x: number;
  y: number;
}

export interface Extractor extends Equipment {
  rotation_type: RotationType;
  power: number;
  noiseLevel: number;
  minimumExtraction: number;
  maximumExtraction: number;
}

export interface ExtractorDto extends EquipmentDto {
  vrotation: RotationTypeDto;
  puissance: number;
  bruit: number;
  debitEncrasse: number;
  debitNeuf: number;
}

export enum RotationType {
  set = "SET",
  variable = "VARIABLE",
}

export enum RotationTypeDto {
  fixe = "Fixe",
  variable = "Variable",
}

//For wastes_decontamination or workers_decontamination
export interface AirLock extends Equipment {
  airLockCount: number;
}
export interface AirLockDto extends EquipmentDto {
  nbSas: number;
}

export enum EquipmentTypeBoard {
  extractors = "ExtractorBoard",
  airEntry = "AirEntryBoard",
  airLocks = "AirLocksBoard",
}

/**
 * Wrap the response of getEquipment request.
 * It contains the list of equipment in the requested page and
 *  the total number of equipments found in all pages.
 */
export interface EquipmentListWrapper {
  equipmentList: Equipment[];
  totalEquipmentCount: number;
}
